import CRUD from '../base/crud'

class FacilityCRUD extends CRUD {
  getFacility(locationId) {
    return this.one(locationId)
  }

  getCurrentFacilityData(locationId, params) {
    return this.request({
      method: 'GET',
      url: `${this.url}/${locationId}/consumption`,
      params,
    })
  }

  getFacilityPerfomanceData(locationId, params) {
    return this.request({
      method: 'GET',
      url: `${this.url}/${locationId}/performance`,
      params,
    })
  }

  getHeatMatData(locationId, params) {
    return this.request({
      method: 'GET',
      url: `${this.url}/${locationId}/heatmap`,
      params,
    })
  }

  getEquipmentFilterData(locationId, params) {
    return this.request({
      url: `${this.url}/${locationId}/equipment/filters`,
      params,
    })
  }

  getEquipmentConsumptionData(locationId, params) {
    return this.request({
      url: `${this.url}/${locationId}/equipment/consumption`,
      params,
    })
  }
}

export default function facilityCRUD(request) {
  return new FacilityCRUD({
    url: '/location',
    request,
  })
}
